/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="payroll.module.ts" />

module Meevo.Plugins.Payroll {
    class PayrollAdpSubmitLogController {
        static $inject = ["meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.components.common.PayRollService',
            "$rootScope",
            "$scope",
            "$state",
            "$filter",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout",
            "payrollPeriod"]

        protected showSearch: boolean;

        protected endpoint: string;
        protected items: any;
        protected startDate: any;
        protected endDate: any;
        protected hasConflicts: boolean;
        protected currentPayroll: boolean;
        protected openPayroll: boolean;
        protected archivedPayroll: boolean;
        protected employeeDetail: Model.DataDetail;
        protected servicePayroll: boolean;
        protected retailPayroll: boolean;
        protected isErrorPayroll: boolean;
        protected terminatedDate: any;
        private currentEmployee: any;

        protected payrollItem: any;
        protected employeePayrolls: any;
        protected employeeFilter: any;
        protected employeeCatFilter: any;
        public showAdvancedMobile: boolean;
        public reprocessAll: boolean;
        public numItemsProcessing: number;
        public isAdpIntegrationEnabled: boolean = true;
        public entries: any[] = null;
        public hasLoaded = false;

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected payrollService: Meevo.Components.Common.PayRollService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected $filter: ng.IFilterService,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            public payrollPeriod: IPayrollPeriod) {
            
            if (payrollPeriod.payrollPeriod_ADPPeriod_LId) {
                this.payrollService.getAdpSubmitLog(payrollPeriod.payrollPeriod_ADPPeriod_LId).then(resp => {
                    this.entries = resp.data;
                    this.entries.forEach(entry => {
                        // TODO: Use pipe in view from standard i18n Meevo date provider
                        entry.localDate = moment(entry.sentDate).format('ddd M/DD/YYYY h:MM:ss A');                        
                    });
                    this.hasLoaded = true;
                });
            } else {
                this.hasLoaded = true;
            }
        }

        public close(): void {
            this.modalService.hide();
        }
    }

    angular.module("meevo.plugins.payroll")
        .controller("meevo.plugins.payroll.AdpSubmitLogController", PayrollAdpSubmitLogController);
}
